import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=a623b276&scoped=true&"
import script from "./noticelist.vue?vue&type=script&lang=js&"
export * from "./noticelist.vue?vue&type=script&lang=js&"
import style0 from "./noticelist.vue?vue&type=style&index=0&id=a623b276&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a623b276",
  null
  
)

export default component.exports